<template>
	<v-container>
		<section class="intro-section" id="home">
			<v-row class="my-10 px-5 grey lighten-3" style="height: 290px">
				<v-col md="12" cols="12" class="pa-3 font-weight-bold py-5 justify-center text-center">
					<h2 class="display-3">Your Number 1 <span class="green--text">Polling, Voting</span> & <span class="pink--text">Mass</span>
						Reachout Solution
					</h2>
					<h2 class="my-12 font-weight-medium">Let us help you acquire, verify and get opinions about you or your brand.</h2>
					<br/>
				</v-col>
			</v-row>
		</section>
		<section class="experiance py-6">
			<v-container>
				<h4 class="display-2 text-center">How it Works</h4>
				<v-timeline :dense="$vuetify.breakpoint.smAndDown">
					<v-timeline-item v-for="(exper,index) in experience" :key="index"
													 :color="index % 2 === 0 ?'pink':'green'">
						<v-card class="rounded-xl">
							<v-card-title class="" :color="index % 2 === 0 ?'pink':'green'">
								{{ exper.title }}
							</v-card-title>
							<v-card-text class="ma-0">
								{{ exper.description }}
							</v-card-text>
						</v-card>
					</v-timeline-item>
				</v-timeline>
			</v-container>
			<!--      </v-img>-->

		</section>
		<v-divider class="my-12 grey"/>
		<section class="portfolio">
			<h4 class="display-2 text-center">Recent Elections</h4>
			<v-slide-group
					class="pa-4"
					active-class="success"
					show-arrows
			>
				<v-slide-item v-for="(slider,index) in elections" :key="index">
					<v-card height="350" width="350" class="mx-4 mb-4">
						<v-img
								:src="slider.image??require('../assets/ken.jpg')"
								height="200px"
						></v-img>

						<v-card-title>
							Client: {{ slider.client }}
						</v-card-title>

						<v-card-subtitle>
							Participants: {{ slider.participants }}
							<br/>
							Questions: {{ slider.questions }}
							<br/>
							Response Rate: {{ slider.rRate }}
							<br/>
							Methods: {{ slider.methods }}
						</v-card-subtitle>

					</v-card>
				</v-slide-item>
			</v-slide-group>
		</section>
		<v-divider class="my-12 grey"/>
		<section class="portfolio">
			<h4 class="display-2 text-center">Recent Polls</h4>
			<v-slide-group
					class="pa-4"
					active-class="success"
					show-arrows
			>
				<v-slide-item v-for="(slider,index) in sliders" :key="index">
					<v-card height="350" width="350" class="mx-4 mb-4">
						<v-img
								:src="slider.image"
								height="200px"
						></v-img>

						<v-card-title>
							County: {{ slider.county }}
						</v-card-title>

						<v-card-subtitle>
							Participants: {{ slider.participants }}
							<br/>
							Questions: {{ slider.questions }}
							<br/>
							Response Rate: {{ slider.rRate }}
							<br/>
							Methods: {{ slider.methods }}
						</v-card-subtitle>

					</v-card>
				</v-slide-item>
			</v-slide-group>
		</section>

		<v-footer class="mt-4">
			<v-col
					class="text-center"
					cols="12"
			>
				<strong>Copyright Politik.sms ©{{ new Date().getFullYear() }}. All rights reserved
				</strong>
			</v-col>
		</v-footer>

	</v-container>
</template>

<script>
export default {
	name: 'HelloWorld',

	data: () => ({
		drawer: null,
		items: [
			{title: 'HTML', value: 100, color: 'light-blue'},
			{title: 'CSS', value: 100, color: 'deep-orange'},
			{title: 'Javascript', value: 70, color: 'light-green'},
			{title: 'Vuejs', value: 80, color: 'blue'},
			{title: 'Vuetify', value: 90, color: 'black'},
			{title: 'PHP', value: 100, color: 'red'},
		],
		experience: [
			{
				title: 'Sign up',
				date: '',
				institute: '',
				description: 'Register with us to access a web portal to manage and track your audience'
			},
			{
				title: 'Create Your Campaign',
				date: 'March 2020 - Present',
				institute: 'Web Burden',
				description: 'Could be a poll, a vote or a message.'
			},
			{
				title: 'Send',
				date: 'March 2020 - Present',
				institute: 'Web Burden',
				description: 'Select your electoral region or target people and hit send'
			},
			{
				title: 'Feed Back',
				date: 'March 2020 - Present',
				institute: 'Web Burden',
				description: 'Check the impact of your campaign via  our dashboards, set up a poll to get definitive results.'
			},
		],
		sliders: [
			{
				county: "Murang'a",
				participants: "158,000",
				questions: 3,
				rRate: "65%",
				methods: "USSD",
				image: require('../assets/counties/muranga.png')
			},
			{
				county: "Nairobi",
				participants: "2,456,670",
				questions: 3,
				rRate: "45%",
				methods: "USSD,WEB",
				image: require('../assets/counties/nairobi.png')
			},
			{
				county: "Embu",
				participants: "198,178",
				questions: 2,
				rRate: "78%",
				methods: "USSD,WEB",
				image: require('../assets/counties/embu.png')
			},
			{
				county: "Kirinyaga",
				participants: "204,698",
				questions: 5,
				rRate: "67%",
				methods: "USSD,WEB",
				image: require('../assets/counties/kirinyaga.png')
			},
			{
				county: "Nyandarua",
				participants: "97,365",
				questions: 3,
				rRate: "71%",
				methods: "USSD",
				image: require('../assets/counties/nyandarua.png')
			}
		],
		elections: [
			{
				client: "JKUAT",
				participants: "600",
				questions: 8,
				rRate: "85%",
				methods: "WEB",
			}
		],
	}),
}
</script>